document.addEventListener( 'DOMContentLoaded', function () {
 
    // Attach click event to all anchor tags with href starting with '#'
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault(); // Prevent default anchor behavior

        // Get the target element's position
        const target = $(this.getAttribute('href'));

        if (target.length) {
            // Animate smooth scroll to the target
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 800); // 800ms duration for the scroll
        }
    });
 
 $('.thumbnail-list li:first-child .thumbnail').trigger('click');
  // document.addEventListener('click', function(e) {
  //     if (e.target.matches('.gallery_nav-btn.nav-btn-left')) {
  //         e.preventDefault();
  //        setTimeout(function(){
  //         var currentThumbnail = document.querySelector('.thumbnail[aria-current]');
  //         var prevThumbnail = currentThumbnail.parentElement.previousElementSibling.querySelector('.thumbnail');
  //         if (prevThumbnail) {
  //             var clickEvent = new Event('click', { bubbles: true });
  //             prevThumbnail.dispatchEvent(clickEvent);
  //         }
  //         },500)
  //     } 
  // });
  //  document.addEventListener('click', function(e) {
  //     if (e.target.matches('.gallery_nav-btn.nav-btn-right')) { 
  //         e.preventDefault();
  //       setTimeout(function(){
  //         var currentThumbnail = document.querySelector('.thumbnail[aria-current]');
  //         var nextThumbnail = currentThumbnail.parentElement.nextElementSibling.querySelector('.thumbnail');
  //         if (nextThumbnail) {
  //             var clickEvent = new Event('click', { bubbles: true });
  //             nextThumbnail.dispatchEvent(clickEvent);
  //         }
  //         },500)
  //     }
  // });
  
    $(document).on("click", ".play-btn_video", function () {
      $(this).parent().toggleClass("active");
      if ($(this).parent().hasClass("active")) {
        $(this).parent().find("video")[0].play();
      } else {
        $(this).parent().find("video")[0].pause();
      }
    });
    $(document).on("click", ".header_megamenu_box .mega-menu__list .mega-menu__link", function (e) {
      e.preventDefault();
      var id = $(this).attr('id');
      console.log(id);
      $('.header_megamenu_box .mega-menu__list .mega-menu__link').removeClass('active');
      $(this).addClass('active');
      $('.mega-menu_products .mega-menu_prod_box').removeClass('active');
      $('.mega-menu_products .mega-menu_prod_box[data-id="'+id+'"]').addClass('active');
    });
    var swiper = new Swiper(".ctm_coll-list_img", {
      loop: false,
      slidesPerView: 1.2, // Show partial slides on each side
      spaceBetween: 13.42, // Space between slides
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 13.42,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 39,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 59.67,
        },
      },
    });
    var swiper = new Swiper(".ctm_coll-slide_img-list", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    var reviewSwiper = new Swiper(".featured-review-slide", {
      loop: true,
      slidesPerView: 1, // Show partial slides on each side
      spaceBetween: 13.42, // Space between slides
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 13.42,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });

    // var moduleImage = new Swiper(".moduleImage", {
    //   loop: true,
    //   slidesPerView: 1,
    //   freeMode: true,
    //   watchSlidesProgress: true,
    // });
    // var moduleMain = new Swiper(".moduleMain", {
    //   loop: true,
    //   navigation: {
    //     nextEl: ".module1_next",
    //     prevEl: ".module1_prev",
    //   },
    //   thumbs: {
    //     swiper: moduleImage,
    //   },
    // });

  var swiper = new Swiper(".moduleMain", {
      slidesPerView: 1,
      freeMode: false,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".moduleImage", {
      effect: "fade",
      loop: true,
      navigation: {
        nextEl: ".module1_next",
        prevEl: ".module1_prev",
      },
      thumbs: {
        swiper: swiper,
      },
    });

    var swiperColumnvideo = new Swiper(".column-videos__box", {
      loop: false,
      slidesPerView: 2.4, // Show partial slides on each side
      spaceBetween: 18.64, // Space between slides
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 13.42,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 27,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 27,
          centeredSlides: false,
        },
      },
    });
    $(document).on('click','.addonsAddToCart',function(e){
      e.preventDefault();
      var id = $(this).data('id');
      var parent=$(this).closest('label');
      var qty = $(parent).find('input[type="number"]').val();
      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:{quantity:qty,id:id},
        success: function(data){
          fetch("/cart/update.js", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                  updates: {},
                  sections: ["cart-drawer", "cart-icon-bubble"]
              })
          }).then((res) => res.json()).then((cartData) => {
              document.querySelector("cart-drawer").renderContents(cartData);
              document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
          });

        }
      });
    });

  var Blogslider = new Swiper(".blogSlider", {
    loop: false,
    slidesPerView: 1.2, // Show partial slides on each side
    spaceBetween: 20.42, // Space between slides
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 18.42,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 27,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 47,
          centeredSlides: false,
        },
      },
    });
   $(document).ready(function(){
 //listen to the promo button click
 $('#redemDevPromo').on('click', function(event){
 //disable the button event
 event.preventDefault();
 //write the url format
 var theUrl = '/checkout?discount=';
 //grab the discount code from the input
 var theDiscount = $('#devPromo').val();
 //full url to redirect to checkout with promo code
 var toRedirect = theUrl+theDiscount;
 console.log(toRedirect);
 //redirect
 window.location.href = toRedirect;
 });
 });
 $(document).ready(function () {
  const $checkbox = $('#defaultOpenCheckbox'); // Assume you have a checkbox
  const $details = $('#Details-{{ block.id }}-{{ section.id }}');

  if ($checkbox.length && $details.length) {
    $checkbox.on('change', function () {
      if (this.checked) {
        $details.attr('open', '');
      } else {
        $details.removeAttr('open');
      }
    });
  }
});

},false);

$(document).on('shopify:section:load', function(event) { 
    var swiper = new Swiper(".ctm_coll-list_img", {
      loop: true,
      slidesPerView: 1.2, // Show partial slides on each side
      spaceBetween: 13.42, // Space between slides
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 13.42,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 39,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 59,
        },
      },
    });
    var swiper = new Swiper(".ctm_coll-slide_img-list", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    var reviewSwiper = new Swiper(".featured-review-slide", {
      loop: true,
      slidesPerView: 1, // Show partial slides on each side
      spaceBetween: 13.42, // Space between slides
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 13.42,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });

    var moduleImage = new Swiper(".moduleImage", {
      loop: true,
      slidesPerView: 1,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var moduleMain = new Swiper(".moduleMain", {
      loop: true,
      navigation: {
        nextEl: ".module1_next",
        prevEl: ".module1_prev",
      },
      thumbs: {
        swiper: moduleImage,
      },
    });

    var swiperColumnvideo = new Swiper(".column-videos__box", {
      loop: true,
      slidesPerView: 2.5, // Show partial slides on each side
      spaceBetween: 13.42, // Space between slides
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 13.42,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 39,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 59,
          centeredSlides: false,
        },
      },
    });

    $(document).on('click','.addonsAddToCart',function(e){
      e.preventDefault();
      var id = $(this).data('id');
      var parent=$(this).closest('label');
      var qty = $(parent).find('input[type="number"]').val();
      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:{quantity:qty,id:id},
        success: function(data){
          fetch("/cart/update.js", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                  updates: {},
                  sections: ["cart-drawer", "cart-icon-bubble"]
              })
          }).then((res) => res.json()).then((cartData) => {
              document.querySelector("cart-drawer").renderContents(cartData);
              document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
          });

        }
      });
    });

      $(document).on('click','.product__accordion .accordion__content p a',function(){
           $('html, body').animate({
                    scrollTop: $("https://reduceeveryday.com/pages/faq#faq-gurantee").offset().top
                }, 2000);
    });
  
  });

class GlobalModalHandler {
  constructor() {
    this.initializeHashLinks();
  }

  initializeHashLinks() {
    // Escuchar clicks en todo el documento
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;

      const modalId = link.getAttribute('href').substring(1);
      if (!modalId) return;

      event.preventDefault();
      this.openModal(modalId, link);
    });
  }

  openModal(modalId, trigger) {
    const modal = document.querySelector(`#${modalId}`);
    if (modal && typeof modal.show === 'function') {
      modal.show(trigger);
    }
  }
}

// Inicializar el manejador global cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new GlobalModalHandler();
});
